import React, { useState } from 'react';
import { FiShield, FiKey, FiRefreshCw } from 'react-icons/fi';
import { PermissionsSkeleton } from 'components/PortalLoading';
import useFetchPermissions from 'api/RoleResource/useFetchPermissions';
import useFetchRoles from 'api/RoleResource/useFetchRoles';
import Admin2 from 'layouts/Admin2';
import Permissions from './Permissions';
import Roles from './Roles';
import RoleDetails from './Roles/RoleDetails';
import './rolesPermissions.css';

export default function RolesPermissions() {
    const permissionQuery = useFetchPermissions();
    const roleQuery = useFetchRoles();
    const [view, setView] = useState('roles');
    const [selectedId, setSelectedId] = useState(null);
    const roles = roleQuery.data?.data?.data || [];
    const permissions = permissionQuery.data?.data || [];
    const selectedRole = roles.find((role) => role.id === selectedId) || roles[0];
    const isLoading = permissionQuery.isLoading || roleQuery.isLoading;
    const isError = permissionQuery.isError || roleQuery.isError;

    return <Admin2 pageTitle="Roles & permissions">
        <div className="access-page">
            {isLoading ? <PermissionsSkeleton /> : isError ? <div className="access-empty access-panel" role="alert">
                <FiShield aria-hidden="true" /><h2>Unable to load access settings</h2>
                <p>Please try again to view roles and permissions.</p>
                <button type="button" className="portal-button" disabled={permissionQuery.isFetching || roleQuery.isFetching}
                    onClick={() => { permissionQuery.refetch(); roleQuery.refetch(); }}><FiRefreshCw aria-hidden="true" />Try again</button>
            </div> : <>
                <div className="access-view-bar">
                    <div className="access-views" role="group" aria-label="Access settings view">
                        <button type="button" aria-pressed={view === 'roles'} onClick={() => setView('roles')}><FiShield aria-hidden="true" />Roles<span>{roles.length}</span></button>
                        <button type="button" aria-pressed={view === 'permissions'} onClick={() => setView('permissions')}><FiKey aria-hidden="true" />Permission directory<span>{permissions.length}</span></button>
                    </div>
                    <span className="access-view-hint">{view === 'roles' ? 'Choose a role to explore its access' : 'All permissions available in your workspace'}</span>
                </div>
                {view === 'roles' ? <div className="access-workspace">
                    <Roles roles={roles} selectedId={selectedRole?.id} onSelect={setSelectedId} />
                    {selectedRole ? <RoleDetails key={selectedRole.id} role={selectedRole} permissions={permissions} /> :
                        <section className="access-panel access-empty"><FiShield aria-hidden="true" /><h2>No roles available</h2><p>Roles will appear here when they are available.</p></section>}
                </div> : <Permissions permissions={permissions} />}
            </>}
        </div>
    </Admin2>;
}
